import axios from "axios"

const API_PREFIX = "/api/gold"

export const apiGoldTraderPresent = () => {
    return axios.get(`${API_PREFIX}/public/trader/present`)
}

export const apiGoldTraderHistory = date => {
    return axios.get(`${API_PREFIX}/public/trader/history/list?date=${date}`)
}

export const apiGoldHistoryGraph = (period, sampling = 0, startTimeframe = "") => {
    return axios.get(`${API_PREFIX}/public/trader/history/graph?period=${period}&sampling=${sampling}&startTimeframe=${startTimeframe}`)
}

export const apiGoldSpotLastQuote = ({ from, to }) => {
    return axios.get(`${API_PREFIX}/spot/public/v1/last_quote/currencies/${from}/${to}`)
}

export const apiGoldSpotRealtimeConversion = ({ from, to }) => {
    return axios.get(`${API_PREFIX}/spot/public/v1/conversion/${from}/${to}?amount=100&precision=2`)
}

export const apiGoldSpotHistoryGraph = ({ multiplier = 1, timespan = 'day', from, to, currency = "C:XAUUSD" }) => {
    return axios.get(`${API_PREFIX}/spot/public/v2/aggs/ticker/${encodeURIComponent(currency)}/range/${multiplier}/${timespan}/${from}/${to}`)
}

export const apiGoldSpotPreviousClose = (currency = "C:XAUUSD") => {
    return axios.get(`${API_PREFIX}/spot/public/v2/aggs/ticker/${encodeURIComponent(currency)}/prev`)
}

export const apiGoldSpotSnapshot = ({period, marketStatus, snapshotKey = "", startTimeframe = ""}) => {
    return axios.get(`${API_PREFIX}/public/spot/snapshot?period=${period}&marketStatus=${marketStatus}&snapshotKey=${snapshotKey}&startTimeframe=${startTimeframe}`)
}